import AbstractWebsocket from "./AbstractWebsocket.ts";

class CalibrationWebsocket extends AbstractWebsocket {

    constructor() {
        super("calibrations")
    }

    public getAllUpdates() {
        return this.baseUrl;
    }

}

export default CalibrationWebsocket